import(/* webpackMode: "eager" */ "/app/components/blogs/blogs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/hero/HeroSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/hero/TrustedBrands.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/homepage/SingleBanner.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/homepage/tab_swiper/slide_component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/homepage/TextCTABanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/homepage/video_swipe_module/VideoSwipeModule.tsx");
;
import(/* webpackMode: "eager" */ "/app/components/ui/button.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
